import { useCallback, useState } from 'react';
import { type LoyaltyRegistrationStep } from '../../api/loyalty';
import { useModalController, type UseModalControllerPayload } from './useModalController';

export interface UseLoyaltyRegisterModalControllerPayload extends Omit<UseModalControllerPayload, 'onOpen'> {
    onOpen: (step: LoyaltyRegistrationStep) => void;
    step: LoyaltyRegistrationStep;
}

export const useLoyaltyRegisterModalController = (): UseLoyaltyRegisterModalControllerPayload => {
    const modalProps = useModalController();
    const [step, setStep] = useState<LoyaltyRegistrationStep>('last-step');

    const onOpen = useCallback(
        (step: LoyaltyRegistrationStep) => {
            setStep(step);
            modalProps.onOpen();
        },
        [modalProps]
    );

    return {
        ...modalProps,
        onOpen,
        step,
    };
};
